import {
  SUPERSET_CANVAS_CHART_LIST,
  SUPERSET_CANVAS_CHART_LIST_EMPTY,
  SUPERSET_CANVAS_CHART_LIST_ERROR,
  SUPERSET_CANVAS_CHART_LIST_SUCCESS,
} from '../../../../../actionType';

const initialState = {
  data: [],
  message: null,
  loading: false,
  success: false,
  error: false,
};

const SupersetCanvasChartList = (state = initialState, action) => {
  switch (action.type) {
    case SUPERSET_CANVAS_CHART_LIST:
      state = { ...state, loading: true, success: false, error: false, message: null };
      break;

    case SUPERSET_CANVAS_CHART_LIST_SUCCESS:
      state = { ...state, data: action.payload, loading: false, success: true, error: false, message: null };
      break;

    case SUPERSET_CANVAS_CHART_LIST_ERROR:
      state = { ...state, data: [], loading: false, success: false, error: true, message: action.payload };
      break;

    case SUPERSET_CANVAS_CHART_LIST_EMPTY:
      state = { ...initialState };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SupersetCanvasChartList;
